import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableAffaireCreatePage = withAsyncLoading(async () =>
    import('./AffaireCreatePage').then((res) => res.AffaireCreatePage)
);

export { LoadableAffaireCreatePage };
